import { useEffect, useState } from 'react'

const INTERACTION_EVENTS = [
  'pointerdown',
  'keydown',
  'touchstart',
  'scroll',
  'wheel',
]

/**
 * Returns false until the visitor first interacts with the page (pointer,
 * key, touch, or scroll). Used to defer third-party resources (Google Maps,
 * background video) so no third-party request fires on bare page load,
 * before any user interaction.
 */
export function useFirstInteraction() {
  const [interacted, setInteracted] = useState(false)

  useEffect(() => {
    if (interacted) return
    const activate = () => setInteracted(true)
    INTERACTION_EVENTS.forEach((event) =>
      window.addEventListener(event, activate, { once: true, passive: true })
    )
    return () =>
      INTERACTION_EVENTS.forEach((event) =>
        window.removeEventListener(event, activate)
      )
  }, [interacted])

  return interacted
}
